$(document).ready(() => {

    $(document).on('click', '.message-edit', function () {
        let $div = $(this).closest('.message');
        $('#edit-message').val($div.data('message')).focus();
        $('#form-new').hide();

        $('div.message-edit-options').removeClass('active');

        let $form = $('#form-edit');
        $form.attr('action', $form.data('url') + '/' + $div.data('id')+ '#msg');
        $form.show();
    });

    $(document).on('click', '.message-delete', function () {
        if (confirm("Do you really want to delete this message?") == true) {
            let $div = $(this).closest('.message');
            let $form = $('#form-delete');
            $form.attr('action', $form.data('url') + '/' + $div.data('id') + '#msg');
            $form.submit();
        } else {
            $('div.message-edit-options').removeClass('active');
        }
    });

});